<template>
    <section class="no-notifucation">
        <div class="container">
            <div class="no-notifucation-icon">
                <img loading="lazy" src="@/assets/images/no-data-img.webp" alt="no-data-img">
            </div>
            <div class="thm-heading">
                <h3>{{$t('no-data-found', 'No data found')}}!</h3>
                <!-- <p>{{$t('cant-find-any-item', `We can't find any item matching your search.`)}}</p> -->
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "NoDataFound",
}
</script>